export default "__VITE_ASSET__dv_BJ9v9__"